import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_REFERENCES';

 
export async function getAllReferences(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const response = await axios.get(
            `${URL}/references/?page=${page}&${params}`,

            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData?.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des références',
            error: error
        });
    }
}
